/**
 * Heading component with Dashboard3 text color tokens
 *
 * Note: Must be "use client" because it uses useThemeTokens hook
 *
 * @example
 * ```tsx
 * <Heading size="lg">Page Title</Heading>
 * ```
 */

"use client";

import {
  Heading as ChakraHeading,
  type HeadingProps as ChakraHeadingProps,
} from "@chakra-ui/react";
import { useThemeTokens } from "@/lib/theme/tokens";

export interface HeadingProps extends ChakraHeadingProps {
  /**
   * Text color variant based on Dashboard3 theme
   * - primary: Main text (92% opacity)
   * - secondary: Secondary text (68% opacity)
   */
  variant?: "primary" | "secondary";
}

export const Heading = ({ variant = "primary", ...props }: HeadingProps) => {
  const theme = useThemeTokens();

  const colorMap = {
    primary: theme.text.primary,
    secondary: theme.text.secondary,
  };

  return <ChakraHeading color={colorMap[variant]} {...props} />;
};
